import { v4 as uuid } from 'uuid';
import { OfferEligibilityType, OfferType } from 'legacy/events/types';

// Helper function to create initial values from existing offer
export const createInitialValuesFromExistingOffer = (
  existingOffer: any
): OfferType => ({
    name: existingOffer.name,
    eligibilityCriteria: existingOffer.eligibilityCriteria.map(
      (criteria: any) => ({
        id: uuid(),
        mustHaveTicket: criteria.mustHaveTicket,
        selector: criteria.selector as OfferEligibilityType,
        ...(criteria.selector === OfferEligibilityType.USERS && {
          items: criteria.users
        }),
        ...(criteria.selector === OfferEligibilityType.ORGANIZATIONS && {
          items: criteria.organizations
        }),
        ...(criteria.selector === OfferEligibilityType.ASSOCIATIONS && {
          items: criteria.associations
        })
      })
    ),
    rewards: {
      kickbackRewards: {
        kind: existingOffer.rewards.kickbackRewards[0]?.kind || 'percentage',
        value: existingOffer.rewards.kickbackRewards[0]?.value || 0,
        saleConditions: {
          unit:
            existingOffer.rewards.kickbackRewards[0]?.saleConditions.unit ||
            'ticket',
          tiers:
            existingOffer.rewards.kickbackRewards[0]?.saleConditions.tiers ||
            [],
          minSalesThreshold:
            existingOffer.rewards.kickbackRewards[0]?.saleConditions
              .minSalesThreshold,
          minSalesThresholdEnabled:
            !!existingOffer.rewards.kickbackRewards[0]?.saleConditions
              .minSalesThreshold
        }
      }
    },
    discount: existingOffer.discount,
    contracts: existingOffer.contracts
  });

// Helper function to create default initial values
export const createDefaultInitialValues = (): OfferType => ({
    name: '',
    eligibilityCriteria: [
      {
        id: uuid(),
        mustHaveTicket: false,
        selector: OfferEligibilityType.USERS,
        items: []
      }
    ],
    rewards: {
      kickbackRewards: {
        kind: 'percentage',
        value: 0,
        saleConditions: {
          unit: 'ticket',
          tiers: [],
          minSalesThresholdEnabled: false
        }
      }
    },
    contracts: []
  });

// Helper function to get initial values based on mode
export const getInitialValues = (
  isEditMode: boolean,
  existingOffer: any
): OfferType => {
  if (isEditMode && existingOffer) {
    return createInitialValuesFromExistingOffer(existingOffer);
  }
  return createDefaultInitialValues();
};
